import type { MouseEventHandler, PropsWithChildren, ReactNode } from 'react';

import type { GetExclusiveProps } from '../../types.ts';

export enum TableRowRole {
  GROUP_HEADER = 'GROUP_HEADER',
  GROUP_ELEMENT = 'GROUP_ELEMENT',
  SPACER = 'SPACER',
  DEFAULT = 'DEFAULT',
  SUB_ROW = 'SUB_ROW',
}

export interface TableRowBaseProps extends PropsWithChildren {
  className?: string;
  flash?: boolean;
  highlighted?: boolean;
  rowRole?: TableRowRole;
  dataTestId?: string;
}

export interface TableRowExclusiveProps {
  contents?: ReactNode;
  onClick?: MouseEventHandler<HTMLTableRowElement>;
}

export type TableRowProps = TableRowBaseProps & GetExclusiveProps<TableRowExclusiveProps>;
